module.exports = __webpack_public_path__ + "static/homepage-banner-desk-62fb986647f0546fb400f6d59324c015.png";